// Set the buffer width for the area past the chart in which the event will still render
const bufferWidth = 1;

export default {
	canvasBufferWidth: {
		left: bufferWidth,
		right: bufferWidth
	},
	diameter: 16,
	offsetY: 20,
	padding: 5,
	xAxis: {
		padding: 0
	},
	cluster: {
		distance: 15
	},
	stack: {
		distance: 17
	}
};
